import React from "react";
import SplitPage from "../../common/SplitPage/components/splitPage";
import ConfirmDeliveryForm from "../components";

const ConfirmDelivery = () => {
  return (
    <SplitPage
      contentSide="leftCentered"
      main={<ConfirmDeliveryForm />}
      pageTitle="Confirm Delivery"
    />
  );
};

export default ConfirmDelivery;
